import GATSBY_COMPILED_MDX from "/home/runner/work/seeds/seeds/apps/reference-site/docs/components/changelog/index.mdx";
import React from "react";
import {graphql} from "gatsby";
import Page from "components/page/Page";
import Tabs from "components/Tabs";
import Text from "components/global/Text";
import {Helmet} from "react-helmet";
import Link from "components/Link";
import StatusButton from "components/scorecard/StatusButton";
import {Badge, Icon} from "@sproutsocial/racine";
import Scorecard from "components/scorecard";
const Byline = ({scorecard, meta, location}) => {
  return React.createElement("span", null, scorecard && React.createElement(StatusButton, {
    status: scorecard.status,
    content: React.createElement(Scorecard, scorecard),
    location: location
  }), scorecard?.accessible && React.createElement(Badge, {
    mr: 400,
    badgeColor: "blue",
    size: "large"
  }, React.createElement(Icon, {
    mr: 200,
    name: "check"
  }), "Accessible"), meta);
};
const ComponentPageTemplate = ({data, children, pageContext, location}) => {
  const {page, component} = data;
  const isUsage = page.slug.includes("usage");
  const slug = page.slug;
  const showTabs = component && component.pages;
  const showLead = page.lead === false ? false : true;
  const isSupplemental = page.group && page.group === "Documentation";
  const frontmatter = {
    title: page.title,
    private: page.private,
    excerpt: component ? component.excerpt : page.excerpt,
    systemProps: component ? component.systemProps : undefined,
    lead: page.lead
  };
  const normalizedTitle = page.title.replace(/&nbsp;/g, " ");
  const title = isUsage ? normalizedTitle + " usage" : normalizedTitle;
  const categoryPages = data.categories.nodes.find(node => node.name === "components").items;
  const formatTabTitle = page => {
    if (page.slug.includes("usage")) return "Usage";
    if (page.title === component.name) return "Code";
    return page.title;
  };
  const isMenu = name => {
    switch (name) {
      case "ActionMenu":
      case "SingleSelectMenu":
      case "MultiSelectMenu":
      case "Autocomplete":
      case "NestedMenu":
        return true;
      default:
        return false;
    }
  };
  const githubLink = !isSupplemental ? React.createElement(Link, {
    to: `https://github.com/sproutsocial/seeds/tree/main/seeds-react/seeds-react-${isMenu ? "menu" : component.name.toLowerCase().replace(" ", "")}`
  }, "View on GitHub") : null;
  const scorecard = component ? component.scorecard : null;
  return React.createElement(Page, {
    title: component ? component.name : frontmatter.title,
    pages: categoryPages,
    category: page.category.name,
    tableOfContents: page.tableOfContents,
    isPrivate: frontmatter.private,
    location: location,
    frontmatter: frontmatter,
    byline: React.createElement(Byline, {
      scorecard: scorecard,
      meta: githubLink,
      location: location
    }),
    py: [500, 600, 80]
  }, React.createElement(Helmet, {
    title: title
  }), showTabs && React.createElement("div", null, React.createElement(Tabs, {
    mb: 600
  }, component.pages.map(page => React.createElement(Tabs.Item, {
    to: page.slug,
    active: page.slug === slug,
    key: page.slug
  }, React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: formatTabTitle(page)
    }
  }))))), frontmatter.excerpt && showLead && React.createElement(Text.lead, null, frontmatter.excerpt), React.isValidElement(children) && React.cloneElement(children, {
    systemProps: frontmatter.systemProps
  }));
};
ComponentPageTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(ComponentPageTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const query = graphql`
  query ($id: String!, $componentID: String!) {
    page: document(id: { eq: $id }) {
      id
      tableOfContents
      title
      slug
      private
      excerpt
      content
      category {
        name
      }
      lead
      group
    }

    component: component(id: { eq: $componentID }) {
      name
      excerpt
      systemProps
      pages {
        title
        slug
      }
      scorecard {
        ...scorecardFields
      }
    }

    ...SiteMap
  }
`;
